import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import Footer from "./Footer";
import "../styles/NotFound.scss";
import { isMobile } from "react-device-detect";
import { UserManager } from "oidc-client-ts";
import { OIDC_CONFIG } from "../utility/Keycloak";
import { useAuth } from "react-oidc-context";
import { persistor } from "src/redux/store";
import { errorUpdate } from "src/redux/reducers/LoaderSlice";
import { useAppDispatch } from "src/redux/hooks";
import IdleUserHeader from "./IdleUserHeader";
import { Trans } from "react-i18next";

const IntrospectUserMessage = () => {
  const userManager = new UserManager(OIDC_CONFIG);
  const auth: any = useAuth();
  const dispatch = useAppDispatch();

  const handleLogin = async () => {
    dispatch(errorUpdate({ isError: false, error: null }));
    userManager.removeUser();
    await auth.signinRedirect({
      prompt: "login",
      extraQueryParams: {
        action: "asha_login",
      },
    });
    persistor.purge();
  };

  // constant messages are not moved to locale translation files because there is only english language is required here no other languages.

  return (
    <div className="not-found-background-container">
      <IdleUserHeader />
      <div
        className={
          isMobile
            ? "d-flex flex-column not-found-container-mobile"
            : "d-flex flex-row justify-content-center not-found-container-desktop align-items-baseline"
        }
      >
        <div className="image-container">
          <img src="/icons/404_icon.svg" />
        </div>
        <div className="text-container">
          <div className="text-not-found-title"><Trans i18nKey={'heading_active_session'}></Trans></div>
          <div className="text-not-found-content">
            <Trans i18nKey={'description_active_session1'}></Trans>
          </div>
          <div className="text-not-found-content">
            <Trans i18nKey={'description_active_session2'}></Trans>
          </div>
          <Button className="text-not-button-go-home" onClick={handleLogin}>
            <Trans i18nKey={'go_to_login'}></Trans>
          </Button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default IntrospectUserMessage;
